var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.base, `${_vm.base}-${_vm.size}`, `${_vm.base}-${_vm.variant}`],on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":['fal', _vm.icon]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }